import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44f1e44f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-md-12 px-1 py-3 border-bottom"
}
const _hoisted_2 = { class: "row securities_acquisitions mt-4 px-3" }
const _hoisted_3 = { class: "col-md-12 table-responsive" }
const _hoisted_4 = {
  id: "exA",
  class: "table table-striped table-bordered nowrap w-100"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Month End Dates"),
    /*#__PURE__*/_createElementVNode("th", null, "Details"),
    /*#__PURE__*/_createElementVNode("th", null, "Fees Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Inc GST"),
    /*#__PURE__*/_createElementVNode("th", null, "Paid"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance")
  ])
], -1))
const _hoisted_6 = { style: {"max-width":"250px","white-space":"break-spaces"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fum_id!='')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fees, (fee) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass([{fee_border:fee.fee_border==1}, "main_securities"]),
                    key: fee.fee_id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(fee.fee_date), 1),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(fee.fee_details), 1),
                    _createElementVNode("td", null, _toDisplayString(fee.fee_type==1 ? 'Acquisition Fee' : 'FUM Cash A/C Fee'), 1),
                    _createElementVNode("td", null, _toDisplayString(typeof fee.fee_amount!='undefined' ? fee.currency_symbol+' '+(fee.fee_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1),
                    _createElementVNode("td", null, _toDisplayString(typeof fee.fee_inc_gst_amount!='undefined' ? fee.currency_symbol+' '+(fee.fee_inc_gst_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1),
                    _createElementVNode("td", null, _toDisplayString(typeof fee.fee_paid_amount!='undefined' ? fee.currency_symbol+' '+(fee.fee_paid_amount.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1),
                    _createElementVNode("td", null, _toDisplayString(typeof fee.fee_balance!='undefined' ? fee.currency_symbol+' '+(fee.fee_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})) : ''), 1)
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}